import { computed, ref } from 'vue';
import { useDialog } from '@negar/core';

import {
  BrokerChangeForm,
  BrokerChangesTable,
  BubbleInfoDialog,
  SymbolTradeStateDialog,
  TRADING_STATE_INFO,
} from '@/modules/symbol';

import { i18n } from '@/plugins/i18n';

const { t } = i18n.global;

export default function useSymbolDialogs() {
  const { add: addDialog } = useDialog();

  const openBrokerChangeDialog = () => {
    const isExpandedBrokerChangeDialog = ref(true);

    addDialog({
      title: t('symbol.broker_change'),
      expandable: true,
      defaultExpanded: isExpandedBrokerChangeDialog.value,
      onExpandedUpdate: (newValue) =>
        (isExpandedBrokerChangeDialog.value = newValue),
      expandableLabel: computed(() =>
        isExpandedBrokerChangeDialog.value
          ? t('symbol.close_recent_broker_change_requests')
          : t('symbol.recent_broker_change_requests')
      ),
      content: computed(() => ({
        component: BrokerChangeForm,
        props: {},
      })),
      expandedContent: computed(() => ({
        component: BrokerChangesTable,
        props: {},
      })),
    });
  };
  const openInstrumentFundsBubbleInfoDialog = () => {
    addDialog({
      bodyClass: '!w-[420px]',
      title: t('symbol.bubble.dialogTitle'),
      content: computed(() => ({
        component: BubbleInfoDialog,
        props: {},
      })),
    });
  };

  const openSymbolTradeStateDialog = (tradingStateCode: number) => {
    addDialog({
      bodyClass: '!w-[376px]',
      title: TRADING_STATE_INFO[tradingStateCode].title,
      content: computed(() => ({
        component: SymbolTradeStateDialog,
        props: { tradingStateCode },
      })),
    });
  };

  return {
    openBrokerChangeDialog,
    openInstrumentFundsBubbleInfoDialog,
    openSymbolTradeStateDialog,
  };
}
